import React from 'react';
import LocationTemplate from './LocationTemplate';

const RoseHillPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Rose Hill"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28458"]}
      latitude={34.8268}
      longitude={-78.0258}
      population={1626}
      historicalFact="Named for the wild roses growing on a hill near town; home to the world's largest frying pan."
      nearbyTowns={[
        "Warsaw, NC",
        "Clinton, NC",
        "Turkey, NC",
        "Wallace, NC",
        "Magnolia, NC",
        "Beulaville, NC",
        "Teachey, NC",
        "Faison, NC"
      ]}
    />
  );
};

export default RoseHillPage;